import React from 'react';

const InitialQuestions = ({ questions, answers, onAnswerChange, onSubmit, loading }) => {
  const isFormComplete = answers.every(answer => answer.trim().length > 0);

  return (
    <div className="card">
      <h2>Seed Your Future</h2>
      <p style={{ marginBottom: '2rem' }}>Answer these questions to create your 2035 scenario.</p>
      
      {questions.map((question, index) => (
        <div key={index} className="question">
          <div className="question-text">{question}</div>
          <textarea
            value={answers[index]}
            onChange={(e) => onAnswerChange(index, e.target.value)}
            placeholder="Type your answer here..."
            disabled={loading}
          />
        </div>
      ))}
      
      {loading ? (
        <div className="loading pulse">Creating your future scenario...</div>
      ) : (
        <button onClick={onSubmit} disabled={!isFormComplete}>
          Generate My Scenario
        </button>
      )}
    </div>
  );
};

export default InitialQuestions;
